//
// Copyright (c) 2020 Astute Global, Inc.
//

define([
  "marionette",
  "messaging/messenger",
  "./template/tableOfContentsEntryTemplate.html",
], function (Marionette, Messenger, TableOfContentsEntryTemplate) {
  "use strict";

  var TableOfContentsEntryView = {};

  TableOfContentsEntryView.tableOfContentsEntryView = Marionette.Layout.extend({
    template: TableOfContentsEntryTemplate,
    triggers: {
      "click #deleteTableOfContents": "remove:tableOfContents",
      "click #btnShowHistory": "show:history",
    },
    regions: {
      levels: "#tableOfContentsLevels",
    },
    textboxes: {
      "#tableOfContentsName": {
        enableSelector: ["#tableOfContentsName", "#tableOfContentsNameLabel"],
        modelAttribute: "name",
        placeholder: "admin.tableOfContents.name",
      },
    },
    templateHelpers: {
      getDateDisplay: function (date) {
        return Messenger.reqres.request("get:formatted:date:long", date);
      },
    },
    nameError: function (errorMessage) {
      this.$el
        .find("#tableOfContentsNameError")
        .html('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
  });

  return TableOfContentsEntryView;
});
